import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateTermForm from "../../forms/CreateOrUpdateTermForm";
import { TermResponseDto } from "../../shared/dtos/term/TermResponseDto";

interface UpdateTermModalProps {
  open: boolean;
  onClose: () => void;
  term: TermResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateTermModal: React.FC<UpdateTermModalProps> = ({
  open,
  onClose,
  term,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit: ${term.name}`}
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateTermForm
      isEditing={true}
      term={term}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateTermModal;
